import React from 'react';

import { graphql } from 'gatsby';
import { Box, Image } from '@lucid/components-react';
import { Drupal_ParagraphImageSection, Drupal_ParagraphSeoImage } from 'generated/drupal-graphql';
import { mqMin } from '@lucid/theme';

import type { Lucid } from 'types/types';

const FlexiImageSection = ({
  entity: { fieldImageSectionImage, fieldMaxDesktopWidth },
}: {
  entity: {
    fieldImageSectionImage: { entity: Drupal_ParagraphSeoImage };
    fieldMaxDesktopWidth: Drupal_ParagraphImageSection['fieldMaxDesktopWidth'];
  };
}) => {
  return (
    <Box
      css={(theme: Lucid.Theme) => ({
        label: 'flexiImageSection',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        marginTop: theme.space[6],
        marginBottom: theme.space[6],
      })}
      gridColumn="1 / -1"
    >
      <Box css={{ textAlign: 'center' }}>
        <Image
          css={{
            maxWidth: '100%',
            [mqMin.tabletLandscape]: {
              maxWidth: `${fieldMaxDesktopWidth}%`,
            },
          }}
          imageAlt={fieldImageSectionImage?.entity?.fieldAltText || ''}
          imageSrc={fieldImageSectionImage?.entity?.fieldImageLink || ''}
          loading="lazy"
        />
      </Box>
    </Box>
  );
};

export default FlexiImageSection;

export const query = graphql`
  fragment flexiImageSection on Drupal_ParagraphImageSection {
    fieldMaxDesktopWidth
    fieldImageSectionImage {
      entity {
        ... on Drupal_ParagraphSeoImage {
          fieldImageLink
          fieldAltText
        }
      }
    }
  }
`;
